<template>
  <section class="not-found">
    <div class="not-found__card">
      <h1 class="not-found__title">{{ $t('notFound.title') }}</h1>
      <p class="not-found__text">{{ $t('notFound.text') }}</p>
      <router-link to="/" class="not-found__button">{{ $t('notFound.goHome') }}</router-link>
    </div>
  </section>
</template>

<script>
import { applyMeta } from '../utils/meta'

export default {
  name: 'NotFound',
  mounted() {
    applyMeta({ title: 'Page Not Found | steamplayti.me' })
  },
  beforeUnmount() {
    applyMeta()
  },
}
</script>

<style scoped>
.not-found {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 16px;
}

.not-found__card {
  max-width: 460px;
  width: 100%;
  text-align: center;
  background: rgba(23, 26, 33, 0.9);
  border: 1px solid rgba(102, 192, 244, 0.2);
  border-radius: 16px;
  padding: 32px 24px;
  box-shadow: 0 20px 40px rgba(11, 14, 18, 0.45);
}

.not-found__title {
  font-size: 2rem;
  margin-bottom: 16px;
}

.not-found__text {
  color: var(--muted);
  margin-bottom: 28px;
  line-height: 1.5;
}

.not-found__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px 24px;
  border-radius: 999px;
  background: var(--primary);
  color: #0b0e12;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.2s ease;
}

.not-found__button:hover {
  background: var(--primary-hover);
}
</style>
